"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const abi_1 = require("./abi");
const address_1 = require("./address");
const utils_1 = require("./utils");
const methodCallPrefix = {
    erc20: {
        transfer: utils_1.toEthereumHex(abi_1.Abi.calculateMethodId("transfer(address,uint256)")),
        approve: utils_1.toEthereumHex(abi_1.Abi.calculateMethodId("approve(address,uint256)")),
    },
};
class Erc20TokenTransactionBuilder {
    static buildTransaction(input, json, erc20Token, chainId, fee, signerPubkey) {
        if (json.input.startsWith(methodCallPrefix.erc20.transfer)) {
            const positionTransferMethodEnd = 4;
            const positionTransferRecipientBegin = positionTransferMethodEnd;
            const positionTransferRecipientEnd = positionTransferRecipientBegin + 32;
            const positionTransferAmountBegin = positionTransferRecipientEnd;
            const positionTransferAmountEnd = positionTransferAmountBegin + 32;
            const quantity = abi_1.Abi.decodeUint256(input.slice(positionTransferAmountBegin, positionTransferAmountEnd));
            return {
                kind: "bcp/send",
                chainId: chainId,
                sender: address_1.pubkeyToAddress(signerPubkey),
                fee: fee,
                amount: {
                    quantity: quantity,
                    fractionalDigits: erc20Token.decimals,
                    tokenTicker: erc20Token.symbol,
                },
                recipient: abi_1.Abi.decodeAddress(input.slice(positionTransferRecipientBegin, positionTransferRecipientEnd)),
                memo: undefined,
            };
        }
        else if (json.input.startsWith(methodCallPrefix.erc20.approve)) {
            const positionApproveMethodEnd = 4;
            const positionApproveSpenderBegin = positionApproveMethodEnd;
            const positionApproveSpenderEnd = positionApproveSpenderBegin + 32;
            const positionApproveAmountBegin = positionApproveSpenderEnd;
            const positionApproveAmountEnd = positionApproveAmountBegin + 32;
            const spender = abi_1.Abi.decodeAddress(input.slice(positionApproveSpenderBegin, positionApproveSpenderEnd));
            const quantity = abi_1.Abi.decodeUint256(input.slice(positionApproveAmountBegin, positionApproveAmountEnd));
            return {
                kind: "erc20/approve",
                chainId: chainId,
                fee: fee,
                amount: {
                    quantity: quantity,
                    fractionalDigits: erc20Token.decimals,
                    tokenTicker: erc20Token.symbol,
                },
                spender: spender,
            };
        }
        else {
            throw new Error("unknown erc23 method");
        }
    }
}
exports.Erc20TokenTransactionBuilder = Erc20TokenTransactionBuilder;
//# sourceMappingURL=erc20tokentransactionbuilder.js.map